export const getChipProps = (status, userStatus) => {
  if (status === "completed") {
    return {
      sx: {
        border: "1px solid black",
        color: "black",
        backgroundColor: "transparent",
        textTransform: "capitalize",
      },
    };
  }

  //Requested
  if (status === "pending" && !userStatus) {
    return { color: "primary" };
  }

  //pending
  if (status === "accepted" && !userStatus) {
    return { color: "warning" };
  }

  if (status === "accepted" && userStatus === "Accepted") {
    return { color: "success" };
  }

  if (status === "rejected") {
    return { color: "error" };
  }
};

export const getUserStatusLable = (status, userStatus) => {
  if (status === "completed") {
    return "completed";
  }

  //Requested
  if (status === "pending" && !userStatus) {
    return "submitted";
  }

  if (status === "accepted" && !userStatus) {
    return "pending";
  }

  if (status === "accepted" && userStatus === "Accepted") {
    return "accepted";
  }

  if (status === "rejected") {
    return "rejected";
  }
};
